import React from 'react';
import MiniTable from 'Components/MiniTable';
import { Column } from 'react-table';
import styles from './index.css';

type Props = {
    data: RulePerformanceTableItem[];
    columns: Column<RulePerformanceTableItem>[];
    dataTestId: string;
};

const RulePerformanceTable = ({ data, columns, dataTestId }: Props) => {
    return <MiniTable className={styles.tableContainer} dataTestId={dataTestId} data={data} columns={columns} />;
};

export default RulePerformanceTable;
